module.exports = __webpack_public_path__ + "static/media/helping.ef862678.png";